import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState } from "../../types";

export const setFeatureFlagsLoadingStatus = (
  state: ApplicationState,
  action: PayloadAction<ApplicationState['featureFlags']['loadingStatus']>
) => {
  state.featureFlags.loadingStatus = action.payload;
};
